(() => {
  if (window.__impoundGalaxyGuide) return;
  window.__impoundGalaxyGuide = true;
  const instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const tabs = [...root.querySelectorAll('[data-gg-tab]')];
    const panels = [...root.querySelectorAll('[data-gg-panel]')];
    const activate = index => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index), { signal });
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(next);
        tabs[next].focus();
      }, { signal });
    });
    if (tabs.length && tabs.length === panels.length) {
      activate(0);
      root.classList.add('gg-enhanced');
    }

    const dialog = root.querySelector('[data-gg-dialog]');
    const items = [...root.querySelectorAll('[data-gg-gallery]')];
    let current = 0;
    let trigger;
    if (dialog && typeof dialog.showModal === 'function') {
      const image = dialog.querySelector('img');
      const title = dialog.querySelector('[data-gg-dialog-title]');
      const caption = dialog.querySelector('[data-gg-dialog-caption]');
      const counter = dialog.querySelector('[data-gg-dialog-counter]');
      const original = dialog.querySelector('[data-gg-original]');
      const error = dialog.querySelector('[data-gg-image-error]');
      const show = index => {
        current = (index + items.length) % items.length;
        const item = items[current];
        error.hidden = true;
        image.hidden = false;
        image.alt = item.querySelector('img').alt;
        image.src = item.href;
        title.textContent = item.dataset.title;
        caption.textContent = item.dataset.caption;
        counter.textContent = `${current + 1} / ${items.length}`;
        original.href = item.href;
        dialog.querySelector('[data-gg-animation-note]').hidden = !item.dataset.animation;
      };
      image.addEventListener('error', () => { image.hidden = true; error.hidden = false; }, { signal });
      items.forEach((item, index) => item.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = item;
        show(index);
        dialog.showModal();
      }, { signal }));
      dialog.querySelector('[data-gg-close]').addEventListener('click', () => dialog.close(), { signal });
      dialog.querySelector('[data-gg-prev]').addEventListener('click', () => show(current - 1), { signal });
      dialog.querySelector('[data-gg-next]').addEventListener('click', () => show(current + 1), { signal });
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal });
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      }, { signal });
      dialog.addEventListener('close', () => {
        image.removeAttribute('src');
        trigger?.focus({ preventScroll: true });
      }, { signal });
    }

    const chapterSelect = root.querySelector('[data-gg-chapter-select]');
    chapterSelect?.addEventListener('change', () => {
      const chapter = document.getElementById(chapterSelect.value);
      if (chapter && root.contains(chapter)) window.location.hash = chapter.id;
    }, { signal });
    const chapters = [...root.querySelectorAll('[data-gg-chapter]')];
    const chapterLinks = [...root.querySelectorAll('.gg-nav a[href^="#"]')];
    const nav = root.querySelector('.gg-nav');
    let frame;
    let activeChapter;
    const updateChapter = () => {
      frame = null;
      const offset = parseFloat(getComputedStyle(root).getPropertyValue('--gg-sticky-offset')) || 0;
      const boundary = offset + (nav?.getBoundingClientRect().height || 0) + 32;
      const current = chapters.filter(chapter => chapter.getBoundingClientRect().top <= boundary).at(-1)?.id || '';
      if (current === activeChapter) return;
      activeChapter = current;
      if (chapterSelect) chapterSelect.value = current || chapters[0]?.id || '';
      chapterLinks.forEach(link => {
        if (current && link.hash === `#${current}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    const scheduleChapter = () => { if (!frame) frame = requestAnimationFrame(updateChapter); };
    window.addEventListener('scroll', scheduleChapter, { passive: true, signal });
    window.addEventListener('resize', scheduleChapter, { passive: true, signal });
    scheduleChapter();
    instances.set(root, () => { controller.abort(); cancelAnimationFrame(frame); dialog?.close(); });
  }

  const boot = scope => {
    if (scope.matches?.('[data-gg-guide]')) init(scope);
    scope.querySelectorAll('[data-gg-guide]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-gg-guide]').forEach(root => { instances.get(root)?.(); instances.delete(root); });
  });
})();
